
import InsumosYCapacitaciones from "./InsumosYCapacitaciones";

export default function InsumosYCapacitacionesAP(props) {
  return <InsumosYCapacitaciones {...props} esProgramaAP={true} />;
}